import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
export const StyledIconContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledIconContainer", componentId: "auir-611444a-1xb09hw" }) `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;

  transform: scaleX(${(props) => (props.prev ? -1 : 1)});

  backface-visibility: hidden;

  [dir='rtl'] & {
    transform: scaleX(${(props) => (props.next ? -1 : 1)});
  }
`;
export const StyledCompactWrapper = styled.span.withConfig({ displayName: "auir-611444a-StyledCompactWrapper", componentId: "auir-611444a-4ior8e" }) `
  padding-inline-start: var(${(props) => props.theme.responsive.spacing.xs});
  padding-inline-end: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledArrow = styled.svg.withConfig({ displayName: "auir-611444a-StyledArrow", componentId: "auir-611444a-rjkhpl" }) `
  width: 0.5em;
  height: 0.8125em;
`;
export const StyledPaginationItem = styled.li.withConfig({ displayName: "auir-611444a-StyledPaginationItem", componentId: "auir-611444a-1dv247w" }) `
  display: inline-block;
  flex: 0 0 auto;

  color: var(${(props) => props.theme.colors.interaction.secondary.default});

  > button,
  > a {
    display: inline-block;
    box-sizing: border-box;
    min-width: 24px;
    min-height: 24px;
    margin: 0;
    padding: 0;
    padding-inline-start: var(${(props) => props.theme.responsive.spacing.xs});
    padding-inline-end: var(${(props) => props.theme.responsive.spacing.xs});

    color: inherit;
    font: inherit;
    text-align: center;
    text-decoration: none;

    background-color: transparent;
    border: none;

    transition: 150ms;
    transition-timing-function: var(${(props) => props.theme.easing});
    transition-property: color;

    appearance: none;

    &:hover {
      cursor: pointer;
    }

    &[aria-disabled='true'] {
      cursor: not-allowed;
    }

    &::after {
      display: block;

      border-bottom: 2px solid transparent;

      content: '';
    }
  }

  &:first-of-type > button {
    padding-inline-start: 0;
  }

  &:last-of-type > button {
    padding-inline-end: 0;
  }

  & [aria-current='page'] {
    color: var(${(props) => props.theme.colors.interaction.secondary.active});

    &::after {
      border-color: var(
        ${(props) => props.theme.colors.interaction.secondary.active}
      );
    }
  }

  & [aria-disabled='true'] {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});
  }

  &:hover [aria-disabled='false'] {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }
`;
export const StyledPagination = styled.ul.withConfig({ displayName: "auir-611444a-StyledPagination", componentId: "auir-611444a-3yfz2s" }) `
  display: inline-flex;
  gap: var(
    ${(props) => props.variant === 'minimalWithLabels'
    ? props.theme.responsive.spacing.l
    : props.theme.responsive.spacing.s}
  );
  margin: 0;
  padding: 0;

  list-style: none;
`;
export const StyledContainer = styled.nav.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-16cdiyt" }) `
  ${(props) => injectTypography(props, 'copy1')}
  ${injectSpacing('margin')}
`;
export const StyledCurrentPage = styled.span.withConfig({ displayName: "auir-611444a-StyledCurrentPage", componentId: "auir-611444a-rlvfsp" }) `
  color: var(${(props) => props.theme.colors.interaction.secondary.active});
`;
//# sourceMappingURL=Pagination.styles.mjs.mjs.map